const sizeOrder = ['XS', 'S', 'M', 'L', 'XL'];

export const orderBySize = (sizes: string[]) => {
    sizes.sort((a, b) => {
        return sizeOrder.indexOf(a) - sizeOrder.indexOf(b);
    });
    return sizes;
};
